import { useSettings } from '../../context/SettingsProvider';
import CommentEditor from "./CommentEditor";
import CommentContent from './CommentContent';

export default function CommentsTree({ id, parentId, comments }) {

  const settings = useSettings();

  const comment = comments[id];
  const children = comment.children;
  return (
    <li className={comment.approved ? 'comment' : 'comment comment-on-hold--preview'} id={'comment-' + id}>

      <CommentContent comment={comment} />

      { settings.expandedReply === id &&
        <CommentEditor btnText="POST REPLY" parentId={id} />
      }

      {children.length > 0 &&
        <ul className='comment--children'>
          {children.map(childId => (
            <CommentsTree
              key={childId}
              id={childId}
              parentId={id}
              comments={comments}
            />
          ))}
        </ul>
      }
    </li>
  );
}
